import {useReducer} from 'react'
import Cookies from 'js-cookie'
import {isEmpty} from 'lodash'
import {useLocation} from 'react-router-dom'
import {useSelector} from 'hooks/redux'

const defaultLimit = '10'
const limitKey = (pathname: string, userId: string) => `${pathname.replace(/\//g, '')}#${userId}__disp_alert_limit`

export const getSavedDisplayAlertLimit = (pathname: string, userId: string) => {
  if (window.localStorage) {
    const limit = window.localStorage.getItem(limitKey(pathname, userId))
    if (!isEmpty(limit)) {
      return limit as string
    }
  }
  const limit = Cookies.get(limitKey(pathname, userId))
  return isEmpty(limit) ? defaultLimit : (limit as string)
}

export const saveDisplayAlertLimit = (pathname: string, userId: string, limit: string) => {
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, userId), limit)
  } else {
    Cookies.set(limitKey(pathname, userId), limit)
  }
}

export const useDisplayAlertLimit = (): [string, (value: string) => void] => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0)
  const {pathname} = useLocation()
  const currentUser = useSelector((state) => state.session.currentUser)
  const limit = getSavedDisplayAlertLimit(pathname, currentUser.id)
  return [
    limit,
    (limit) => {
      saveDisplayAlertLimit(pathname, currentUser.id, limit)
      forceUpdate()
    },
  ]
}
